import { render, staticRenderFns } from "./conferenceList.vue?vue&type=template&id=6cf48222&scoped=true&"
import script from "./conferenceList.vue?vue&type=script&lang=js&"
export * from "./conferenceList.vue?vue&type=script&lang=js&"
import style0 from "./conferenceList.vue?vue&type=style&index=0&id=6cf48222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf48222",
  null
  
)

export default component.exports